import React from 'react';
import RegisterVM from './RegisterVM';
import { observer } from 'mobx-react';
import RegistrationPersonalDetailsComponent from './Components/RegistrationPersonalDetailsComponent';
import { RegistrationState } from '../../Models/Registration/Enums/RegistrationState';
import ETViewBase from '../ETViewBase';
import '../../Styles/Registration/Register.scss';
import KYCDDScriptLoaderComponent from './Components/KYCDDScriptLoaderComponent';
import { investorProfileRoute } from '../../Services/RouteService';
import { ExternalRegistrationStep } from '../../Models/Registration/Enums/ExternalRegistrationStep';

@observer
export default class KYCDDRegisterView extends ETViewBase<RegisterVM> {

    constructor(props: unknown) {
        super("KYCDDRegister", RegisterVM, props);
        this.sidebarType = "none";
    }

    protected async initialise() {
        await super.initialise();

        if (this.viewModel.investor.externalRegistrationStepID > ExternalRegistrationStep.Incomplete) {
            this.navigation.navigateInternal(investorProfileRoute.path!);
        }
    }
    
    public render() {
        if (!this.viewModel.investor || !this.viewModel.investor.externalRegistrationID || this.viewModel.investor.externalRegistrationID === "00000000-0000-0000-0000-000000000000") {
            return <p>Loading KYC DD data...</p>;
        }
    
        return (
            <div className="register-main-container">
                {/* Capture basic details on platform first*/}
                {this.viewModel.registrationState === RegistrationState.PersonalDetails && (
                    <div>
                        <RegistrationPersonalDetailsComponent
                            viewModel={this.viewModel.registrationPersonalDetailsComponentVM}
                            registerVM={this.viewModel}
                        />
                    </div>
                )}
                {/* Capture the rest through KYC DD*/}
                {this.viewModel.registrationState !== RegistrationState.AccountCreated && (
                    <div className="kycdd-wrapper">
                        <KYCDDScriptLoaderComponent viewModel={this.viewModel} />
                    </div>
                )}
            </div>
        );
    }
}